<div class="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-luxury-navy dark:via-luxury-charcoal dark:to-luxury-navy transition-all duration-500">
  <!-- Mobile Sidebar Overlay -->
  <div
    *ngIf="isSidebarOpen"
    class="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 md:hidden transition-opacity duration-300"
    (click)="toggleSidebar()"
  ></div>

  <!-- Sidebar -->
  <aside
    [class.translate-x-0]="isSidebarOpen"
    [class.-translate-x-full]="!isSidebarOpen"
    class="fixed top-0 left-0 z-50 w-72 h-screen bg-white/95 dark:bg-luxury-navy/95 backdrop-blur-xl border-r border-gray-200/50 dark:border-primary-800/30 shadow-luxury transition-all duration-300 md:translate-x-0"
  >
    <div class="flex flex-col h-full">
      <!-- Logo -->
      <div class="px-5 py-6 border-b border-gray-200/50 dark:border-primary-800/20 flex items-center justify-center">
        <img
          src="assets/logo.png"
          [alt]="settingsService.getCompanyName()"
          class="block max-w-full h-auto max-h-16 object-contain"
        />
      </div>

      <!-- Navigation -->
      <nav class="flex-1 px-4 py-6 space-y-1.5 overflow-y-auto">
        <a
          *ngFor="let item of mainNavItems"
          [routerLink]="item.route"
          routerLinkActive="bg-primary-500/5 dark:bg-primary-600/10 text-gray-900 dark:text-white border-l-2 border-primary-500/70 dark:border-primary-600/70"
          [routerLinkActiveOptions]="item.route === '/dashboard' ? { exact: true } : { exact: false }"
          class="group flex items-center px-4 py-2.5 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100/80 dark:hover:bg-white/5 transition-all duration-200 hover:translate-x-0.5 active:scale-[0.99]"
        >
          <div class="w-8 h-8 rounded-lg bg-gray-100 dark:bg-white/5 flex items-center justify-center mr-3 group-hover:bg-primary-50 dark:group-hover:bg-primary-600/10 transition-colors">
            <svg class="w-4 h-4 text-gray-600 dark:text-gray-400 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path *ngFor="let path of getNavIconPaths(item.icon)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="path" />
            </svg>
          </div>
          <span class="font-medium text-sm">{{ item.label }}</span>
        </a>

        <div *ngIf="settingsNavItems.length > 0" class="pt-2 mt-2 border-t border-gray-200/50 dark:border-primary-800/20">
          <p class="px-5 py-2 text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Settings</p>
        </div>
        <a
          *ngFor="let item of settingsNavItems"
          [routerLink]="item.route"
          routerLinkActive="bg-primary-500/5 dark:bg-primary-600/10 text-gray-900 dark:text-white border-l-2 border-primary-500/70 dark:border-primary-600/70"
          class="group flex items-center px-4 py-2.5 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100/80 dark:hover:bg-white/5 transition-all duration-200 hover:translate-x-0.5 active:scale-[0.99]"
        >
          <div class="w-8 h-8 rounded-lg bg-gray-100 dark:bg-white/5 flex items-center justify-center mr-3 group-hover:bg-primary-50 dark:group-hover:bg-primary-600/10 transition-colors">
            <svg class="w-4 h-4 text-gray-600 dark:text-gray-400 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path *ngFor="let path of getNavIconPaths(item.icon)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="path" />
            </svg>
          </div>
          <span class="font-medium text-sm">{{ item.label }}</span>
        </a>
      </nav>

      <!-- User Info -->
      <div class="px-4 py-5 border-t border-gray-200/50 dark:border-primary-800/20">
        <div class="mb-3 p-3 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100/50 dark:from-white/5 dark:to-white/5 border border-gray-200/50 dark:border-primary-800/20">
          <p class="text-sm font-semibold text-gray-900 dark:text-white mb-0.5">{{ currentUser?.name }}</p>
          <p class="text-xs text-gray-500 dark:text-gray-400 font-medium capitalize">{{ currentUser?.role }}</p>
        </div>
        <button
          (click)="logout()"
          class="w-full px-4 py-3 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-xl transition-all duration-200 active:scale-[0.98] border border-red-200/50 dark:border-red-900/30 hover:border-red-300 dark:hover:border-red-800"
        >
          Logout
        </button>
      </div>
    </div>
  </aside>

  <!-- Main Content -->
  <div class="md:ml-72">
    <!-- Top Bar -->
    <header class="sticky top-0 z-30 bg-white/80 dark:bg-luxury-navy/80 backdrop-blur-xl border-b border-gray-200/50 dark:border-primary-800/20 shadow-soft">
      <div class="flex items-center justify-between px-4 md:px-6 py-4">
        <button
          (click)="toggleSidebar()"
          class="md:hidden p-2.5 rounded-xl hover:bg-gray-100 dark:hover:bg-white/5 active:scale-95 transition-all duration-200 touch-manipulation"
          aria-label="Toggle menu"
        >
          <svg class="w-6 h-6 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div class="flex items-center space-x-3 ml-auto">
          <app-theme-toggle></app-theme-toggle>
        </div>
      </div>
    </header>

    <!-- Page Content -->
    <main class="p-4 md:p-8 animate-fade-in min-h-[calc(100vh-80px)]">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

